import React, { MouseEventHandler } from "react";

import { Typography } from "@mui/material";

import { UserMeeting } from "@app/common/types";
import { formatStartAndEndTime } from "@app/common/utils";

import { Row } from "@rui/Stack";

import MeetingReportTagsCell from "../MeetingReportTableRow/MeetingReportTagsCell";
import { getReportStartEndTimes } from "../utils";

interface DenseReportCellContentProps {
  report: UserMeeting;
  isSummary?: boolean;
  reason?: React.ReactNode;
  details?: React.ReactNode;
  onTagClick?: MouseEventHandler<HTMLDivElement>;
}

const DenseReportCellContent = ({
  report,
  isSummary = false,
  reason,
  details,
  onTagClick,
}: DenseReportCellContentProps) => {
  const { startTimeToDisplay, endTimeToDisplay } = getReportStartEndTimes(
    report,
    isSummary
  );

  return (
    <>
      <Row paddingBottom={(theme) => theme.spaces.small}>
        <Typography
          whiteSpace="normal"
          variant="labelReg"
          color="shades.neutral.500"
        >
          {startTimeToDisplay?.toLocaleString({
            weekday: "short",
            month: "short",
            day: "numeric",
          })}{" "}
          • {formatStartAndEndTime(startTimeToDisplay, endTimeToDisplay)}
        </Typography>
      </Row>
      <Row>
        <MeetingReportTagsCell
          onClick={onTagClick}
          asCell={false}
          tags={report.tags}
        />
      </Row>
      {reason}
      <Typography variant="bodySecondaryReg" sx={{ whiteSpace: "normal" }}>
        {details}
      </Typography>
    </>
  );
};

export default DenseReportCellContent;
